import { defineMessage } from '@atlassian/jira-intl';
import { BOARD_SOURCE_FIELDS, BOARD_SOURCE_FIELDS_JQLTERM } from './boardTypes.constants.tsx';
import { GenericPicker } from './GenericPicker.tsx';
import { SavedFilterPicker } from './SavedFilterPicker.tsx';
import { TeamPicker } from './TeamPicker.tsx';
import type { BoardSourceFieldComponentMap } from './BoardSourceFieldComponentMap.types.tsx';

const issueTypeFieldLabel = defineMessage({
	id: 'software-board-create.modal.form.source-value-picker.issue-type-field-label',
	defaultMessage: 'Issue type',
	description: 'Label for the issue types field',
});

const teamFieldLabel = defineMessage({
	id: 'software-board-create.modal.form.source-value-picker.team-field-label',
	defaultMessage: 'Team',
	description: 'Label for the team field picker in the board creation modal source value section',
});

const labelsFieldLabel = defineMessage({
	id: 'software-board-create.modal.form.source-value-picker.labels-field-label',
	defaultMessage: 'Label',
	description: 'Label for the labels field picker in the board creation modal source value section',
});

const savedFilterLabel = defineMessage({
	id: 'software-board-create.modal.form.source-value-picker.saved-filter-label',
	defaultMessage: 'Select a saved filter',
	description: 'Label for the saved filter picker',
});

const issueTypeFieldLabelIssueTerminologyRefreshM4 = defineMessage({
	id: 'software-board-create.modal.form.source-value-picker.issue-type-field-label-issue-terminology-refresh-m4',
	defaultMessage: 'Work type',
	description: 'Label for the issue types field',
});

export const boardSourceFieldComponentMap: BoardSourceFieldComponentMap = {
	[BOARD_SOURCE_FIELDS.ISSUE_TYPES]: {
		component: GenericPicker,
		label: issueTypeFieldLabelIssueTerminologyRefreshM4,
		id: BOARD_SOURCE_FIELDS.ISSUE_TYPES,
		extraProps: {
			jqlTerm: BOARD_SOURCE_FIELDS_JQLTERM[BOARD_SOURCE_FIELDS.ISSUE_TYPES],
		},
	},
	[BOARD_SOURCE_FIELDS.TEAM]: {
		component: TeamPicker,
		label: teamFieldLabel,
		id: BOARD_SOURCE_FIELDS.TEAM,
	},
	[BOARD_SOURCE_FIELDS.LABELS]: {
		component: GenericPicker,
		label: labelsFieldLabel,
		id: BOARD_SOURCE_FIELDS.LABELS,
		extraProps: {
			jqlTerm: BOARD_SOURCE_FIELDS_JQLTERM[BOARD_SOURCE_FIELDS.LABELS],
		},
	},
	[BOARD_SOURCE_FIELDS.SAVED_FILTER]: {
		component: SavedFilterPicker,
		label: savedFilterLabel,
		id: BOARD_SOURCE_FIELDS.SAVED_FILTER,
	},
};

export const boardSourceFieldComponentMapOld: BoardSourceFieldComponentMap = {
	[BOARD_SOURCE_FIELDS.ISSUE_TYPES]: {
		component: GenericPicker,
		label: issueTypeFieldLabel,
		id: BOARD_SOURCE_FIELDS.ISSUE_TYPES,
		extraProps: {
			jqlTerm: BOARD_SOURCE_FIELDS_JQLTERM[BOARD_SOURCE_FIELDS.ISSUE_TYPES],
		},
	},
	[BOARD_SOURCE_FIELDS.TEAM]: {
		component: TeamPicker,
		label: teamFieldLabel,
		id: BOARD_SOURCE_FIELDS.TEAM,
	},
	[BOARD_SOURCE_FIELDS.LABELS]: {
		component: GenericPicker,
		label: labelsFieldLabel,
		id: BOARD_SOURCE_FIELDS.LABELS,
		extraProps: {
			jqlTerm: BOARD_SOURCE_FIELDS_JQLTERM[BOARD_SOURCE_FIELDS.LABELS],
		},
	},
	[BOARD_SOURCE_FIELDS.SAVED_FILTER]: {
		component: SavedFilterPicker,
		label: savedFilterLabel,
		id: BOARD_SOURCE_FIELDS.SAVED_FILTER,
	},
};
